import React from "react";
import composedBranchContainer from "../../../containers/BranchContainer";
import Branch from "./Branch";

const BranchComponent = (props) => {
  return <Branch />;
};

export default composedBranchContainer(BranchComponent);
